export function ItemSelectorReducer(state = [], action) {
    switch (action.type) {
        case 'GET_PRODUCT_SUITES':
            return action.payload.result;
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/itemSelector_reducer.js